<template>
  <div class="book-pay-page">
    <div class="pay-top">
      <img src="https://img.yzcdn.cn/upload_files/2020/09/01/FtRc3eDZsjQ4eanK_Or5IL9Q2J_y.png" />
      <div class="word1 div">支付成功</div>
      <div class="word2 div">{{ goodDetails.workbookName }}</div>
      <div class="word3 div">¥{{ transPrice(goodDetails.workbookPrice) }}</div>
      <div class="btn-group">
        <div class="btn1" @click="backBook">返回书籍</div>
        <div class="btn2" @click="orderDetail">订单详情</div>
      </div>
      <div class="word4 div">此书已帮您加入书架，也可以在个人中心 - 已购书籍查看购买记录</div>
    </div>
    <div class="pay-bottom">
      <div class="top-titl">
        <div class="title">推荐</div>
        <div class="change-icon" @click="recommedBook(gradeId)">
          <img
            src="https://img.yzcdn.cn/upload_files/2020/09/01/FhEEcoaYc1aXbO6ddbVlPEcSIz7w.png"
          />换一批
        </div>
      </div>
      <div class="re-book">
        <Grid :cols="3" col-margin="0.64rem" row-margin="0.59rem">
          <GridItem v-for="(item, index) in bookList" :key="index">
            <Book
              class="book__cover"
              :book-name="item.book.abbrName"
              :book-status="item.book"
              :book-img="$env.ossUrl(item.book.thumbCoverPath)"
              :effective-date="item.effectiveDate"
              :order="false"
            />
          </GridItem>
        </Grid>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Grid from '@/components/Grid'
import Book from '../component/book'
import { transPrice } from '@/static/js/zjs.js'
import { getPlatform } from '../../../../library'

export default {
  name: '',
  components: {
    Grid,
    GridItem: Grid.item,
    Book
  },
  data() {
    return {
      goodDetails: {}, // 这本书的id
      bookList: [],
      gradeId: ''
    }
  },
  computed: {
    userPref() {
      return this.$store.userPref
    },
    ...mapGetters(['userGrade'])
  },
  mounted() {
    this.getGoodDetails()
  },
  methods: {
    transPrice,
    // 返回书籍
    backBook() {
      // 这样写的原因是  个人中心中支付成功也会跳转到此成功页面  （勿改）
      window.location.href =
        '/cms/webapp/home/answer/index.html#/textbookDetails?id=' + this.goodDetails.workbookId
    },
    // 订单详情
    orderDetail() {
      window.location.href =
        '/cms/webapp/home/user/userCenter.html#/orderDetail?id=' + this.$route.query.order_id
    },
    /**
     * 查询商品详情
     * 参数 订单id
     */

    getGoodDetails() {
      this.$http
        .get(`/cms/weixin/user/book/order/findGoodsByPayOrderId?id=${this.$route.query.order_id}`)
        .then((res) => {
          this.goodDetails = res.data.payOrder[0]
          // 更新状态
          this.$store.dispatch('answerRight/getSingleBookRight', {
            workbookId: this.goodDetails.workbookId
          })
          this.gradeId = res.data.ids
          this.recommedBook(res.data.ids)
        })
    },
    /** 随机推荐书籍
     * gradeId【年级id】
     */
    recommedBook(gradeId) {
      this.$http
        .get(
          '/mopa/api-answer-card/open/referenced_basicbook/get-random-n?search_EQ_referencedBasicbookPK.appid=' +
            getPlatform().appid +
            '&size=3&search_EQ_book.gradeList.basicbookGradePK.grade=' +
            this.userGrade
        )
        .then((res) => {
          this.bookList = res.data.data
        })
    }
  }
}
</script>

<style lang="scss">
.book-pay-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  background: #fff;
  .pay-top {
    width: 100%;
    text-align: center;
    margin-top: 20px;
    padding: 0 38px 60px;
    img {
      width: 64px;
      height: 64px;
      margin: 0 auto;
      margin-bottom: 8px;
    }

    .word1 {
      font-size: 20px;
      color: #333333;
      font-weight: 500;
      margin-bottom: 8px;
    }
    .word2 {
      font-size: 14px;
      color: #333333;
      margin-bottom: 8px;
    }
    .word4 {
      width: 100%;
      font-size: 12px;
      color: #999999;
      font-weight: 300;
      margin-bottom: 8px;
      margin-top: 20px;
      text-align: left;
    }
    .word3 {
      font-size: 14px;
      color: #666666;
    }
    .btn-group {
      display: flex;
      justify-content: space-between;
      margin-top: 60px;
      div {
        width: 134px;
        height: 36px;
        border: 0.5px solid #999999;
        box-sizing: border-box;
        border-radius: 25px;
        font-size: 14px;
        text-align: center;
        line-height: 36px;
        font-weight: 500;
      }
      .btn1 {
        background: #ffffff;
        color: #333333;
      }
      .btn2 {
        background: #ff2638;
        color: #fff;
        border: none;
      }
    }
  }
  .pay-bottom {
    width: 100%;
    padding: 0 16px;
    .top-titl {
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 18px;
        color: #333333;
        font-weight: 500;
      }
      .change-icon {
        font-size: 14px;
        line-height: 20px;
        color: #ff2638;
        display: flex;
        align-items: center;
        img {
          width: 18px;
          height: 18px;
          margin-right: 8px;
        }
      }
    }
    .re-book {
      margin-top: 12px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
